import { attributeDefinitionIdFormat } from "@redotech/redo-ids-cockroach";
import { AttributeType, OwnerType } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const listAttributeDefinitions = {
  name: "listAttributeDefinitions" as const,
  input: z.object({
    searchText: z.string().optional(),
    ownerType: createEnum(OwnerType).optional(),
    systemAttribute: z.boolean().optional(),
    type: createEnum(AttributeType).optional(),
    defaultField: z.string().nullish(),
  }),

  output: z.object({
    attributeDefinitions: z.array(
      z.object({
        id: attributeDefinitionIdFormat.schema,
        name: z.string(),
        displayName: z.string(),
        description: z.string().optional(),
        type: createEnum(AttributeType),
        ownerType: createEnum(OwnerType),
        enumValues: z.array(z.string()),
        defaultValue: z.json().optional(),
      }),
    ),
  }),
};
